/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withLocalize } from 'react-localize-redux';
import {
  find, get, includes, isEmpty, split,
} from 'lodash';
import axios from 'axios';
import {
  AccountCircle, AccountCircleOutlined, ArrowBack, Close,
  EventAvailable, EventAvailableOutlined, KeyboardArrowDown, KeyboardArrowUp, MenuBook, Message, MessageOutlined,
} from '@material-ui/icons';
import { Link, Redirect } from 'react-router-dom';
import {
  Badge, BottomNavigation, BottomNavigationAction, Button, withStyles,

  Menu, MenuItem, IconButton, Toolbar, AppBar,
} from '@material-ui/core';
import queryString from 'query-string';
import { blankHref, hasUuid, ROUTES, isUnclosableNavRoute } from '../../../constants';
import FetchClientContainer from '../../Client/FetchClient';
import { logoutEvent, navigationViewHomepage } from '../WebAnalytics';
import logoBlue from '../../../Assets/Images/Soothe-logo-blue-svg.svg';
import logoBlueSmall from '../../../Assets/Images/Blue-small-logo-svg.svg';
import userAvatarPlaceholder from '../../../Assets/Images/User_avatar.png';
import './Assets/Styles/Navbar.css';

// Add CSS override for Material-UI MenuItem borders
const menuItemNoBorderStyles = `
  .no-border-bottom {
    border-bottom: none !important;
  }
  .no-border-bottom:hover {
    border-bottom: none !important;
  }
  .no-border-bottom:focus {
    border-bottom: none !important;
  }
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.innerHTML = menuItemNoBorderStyles;
  document.head.appendChild(styleElement);
}
import { ACCEPT_LANGUAGE_HEADER, HOST_ROOT } from '../../../apiConfig';
import { loadClient, setChats } from '../../../Actions';
import ForcedTermsModal from '../ForcedTermsModal';
import { getChatsOfCurrentUser } from '../Helpers';
import ResetPasswordPopups from '../ResetPasswordPopups';
import AccountSidebar from '../AccountSidebar';
import { ReactComponent as CollapseIcon } from '../../../Assets/Images/collapse_icon.svg';
import { ReactComponent as ExpandIcon } from '../../../Assets/Images/expand_icon.svg';

const useStyles = (theme) => ({
  root: {
    alignItems: 'center',
    flexGrow: 1,
    zIndex: 1300,
    '& .MuiAppBar-colorPrimary': {
      backgroundColor: '#FFF',
      color: '#586B94',
      zIndex: 1300,
    },
    '& .MuiIconButton-label .MuiSvgIcon-root': {
      height: '48px',
      width: '48px',
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  collapseIcon: {
    width: 24,
    height: 24,
    color: '#ADB4D2!important',
    transition: 'color 0.2s ease',
    paddingRight: '8px!important',
    marginLeft: '20px!important',
    [theme.breakpoints.down('sm')]: {
      paddingRight: '0!important',
      display: 'block',
      width: '16px!important',
      height: '16px!important',
    },
  },
});
// TODO need to fix the mobile view of the navbar
class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      scrolledDown: false,
      anchorEl: null,
      redirect: false,
      pathname: '/appointments/',
      navigationValue: get(split(window.location.pathname, '/', 2), '1', ''),
      accountSidebarOpen: false,
      mobileAccountDropdownAnchor: null,
    };
    this.showPopover = this.showPopover.bind(this);
    this.logout = this.logout.bind(this);
    this.relevantHeader = this.relevantHeader.bind(this);
    this.bottomNavigation = this.bottomNavigation.bind(this);
    this.fetchInboxChats = this.fetchInboxChats.bind(this);
    this.hasNewMessagesFlag = this.hasNewMessagesFlag.bind(this);
    this.appBarHeader = this.appBarHeader.bind(this);
    this.handleAccountSidebarOpen = this.handleAccountSidebarOpen.bind(this);
    this.handleAccountSidebarClose = this.handleAccountSidebarClose.bind(this);
    this.handleLogoClick = this.handleLogoClick.bind(this);
    this.isNotOnBookingPage = this.isNotOnBookingPage.bind(this);
    this.handleAccountMenuClick = this.handleAccountMenuClick.bind(this);
    this.handleMobileAccountClick = this.handleMobileAccountClick.bind(this);
    this.showMobileAccountDropdown = this.showMobileAccountDropdown.bind(this);
    this.getAccountDropdownTitle = this.getAccountDropdownTitle.bind(this);
  }

  componentDidMount() {
    const self = this;
    window.addEventListener('resize', () => {
      this.setState({ width: window.innerWidth });
    });
    window.addEventListener('scroll', () => {
      if (!self.state.scrolledDown && window.scrollY > 0) {
        self.setState({ scrolledDown: true });
      } else if (window.scrollY === 0 && self.state.scrolledDown) {
        self.setState({ scrolledDown: false });
      }
    });
    if (!includes(window.location.pathname, '/booking/')) {
      this.fetchInboxChats();
    }
  }

  fetchInboxChats() {
    getChatsOfCurrentUser((resp) => {
      this.props.setChats(get(resp, 'data.chat_list', []));
    });
  }

  hasNewMessagesFlag() {
    const hasNewMessages = find(get(this.props, 'chats', []), (el) => !get(el, 'chats.0.seen', false));
    return !isEmpty(hasNewMessages);
  }

  logout() {
    logoutEvent();
    axios.delete(
      `${HOST_ROOT}/users/sign_out`,
      { withCredentials: true },
      ACCEPT_LANGUAGE_HEADER,
    ).then(() => {
      this.props.loadClient({ loggedIn: false });
      window.location.href = `${HOST_ROOT}${ROUTES.index}`;
    }).catch(() => {
      this.props.loadClient({ loggedIn: false });
      window.location.href = `${HOST_ROOT}${ROUTES.index}`;
    });
    this.setState({ anchorEl: null });
  }

  handleAccountSidebarOpen = () => {
    this.setState({ accountSidebarOpen: true, anchorEl: null });
  };

  handleAccountSidebarClose = () => {
    this.setState({ accountSidebarOpen: false });
  };

  handleLogoClick() {
    const { width } = this.state;
    
    if (width > 800) {
      // Desktop: refresh the page
      navigationViewHomepage("jul_2024_booking_enhancements", get(this.props, "jul_2024_booking_enhancements", ""));
      window.location.reload();
    } else {
      // Mobile: scroll to top
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  isNotOnBookingPage() {
    return !includes(window.location.pathname, '/booking');
  }

  getAccountDropdownTitle() {
    const currentPath = window.location.pathname;
    const { width } = this.state;

    if(width > 800){
      return 'Account';
    }
    
    // If on booking page, show "Book Now" 
    if (includes(currentPath, '/booking')) {
      return 'Book Now';
    }
    
    // If on account pages (appointments, account settings, etc.), show "Account"
    if (!includes(currentPath, '/booking')) {
      return 'Account';
    }
    
    // Default to "Account"
    return 'Account';
  }

  handleAccountMenuClick(menuType) {
    switch (menuType) {
      case 'inbox':
        window.location.href = `${HOST_ROOT}/inbox/`;
        break;
      case 'bookings':
        window.location.href = `${HOST_ROOT}/appointments/`;
        break;
      case 'paymentMethods':
        window.location.href = `${HOST_ROOT}/account/payment-methods/`;
        break;
      case 'addressBook':
        window.location.href = `${HOST_ROOT}/account/address-book/`;
        break;
      case 'soothe-pass':
        window.location.href = `${HOST_ROOT}/account/soothe-pass/`;
        break;
      case 'invite-friends':
        window.location.href = `${HOST_ROOT}/account/invite-friends/`;
        break;
      case 'settings':
        window.location.href = `${HOST_ROOT}/account/settings/`;
        break;
      case 'bookNow':
        if (!includes(window.location.pathname, '/booking')) {
          this.setState({ redirect: true, pathname: '/booking/MENU' });
        }
        break;
      default:
        break;
    }
    this.setState({ anchorEl: null });
  }

  handleMobileAccountClick(action) {
    switch (action) {
      case 'account':
        window.location.href = `${HOST_ROOT}/appointments/`;
        break;
      case 'bookNow':
        if (!includes(window.location.pathname, '/booking')) {
          this.setState({ redirect: true, pathname: '/booking/MENU' });
        }
        break;
      default:
        break;
    }
    this.setState({ mobileAccountDropdownAnchor: null });
  }

  showMobileAccountDropdown() {
    const { mobileAccountDropdownAnchor } = this.state;
    
    return (
      <Menu
        style={{ zIndex: '999999999999' }}
        id="mobile-account-menu"
        getContentAnchorEl={null}
        anchorEl={mobileAccountDropdownAnchor}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(mobileAccountDropdownAnchor)}
        onClose={() => this.setState({ mobileAccountDropdownAnchor: null })}
        MenuListProps={{
          style: { backgroundColor: '#FFFFFF', boxShadow: 'none' }
        }}
      >
        <MenuItem 
          onClick={() => this.setState({ mobileAccountDropdownAnchor: null })}
          style={{ 
            justifyContent: 'flex-start', 
            padding: '8px 16px',
            minHeight: '40px',
            backgroundColor: 'transparent',
            borderBottom: 'none!important',
            borderBottomColor: 'transparent',
            borderBottomStyle: 'none',
            borderBottomWidth: '0px',
            boxShadow: 'none',
          }}
          classes={{ root: 'no-border-bottom' }}
        >
          <Close style={{ fontSize: '20px', color: '#586B94' }} />
        </MenuItem>
        <MenuItem onClick={() => this.handleMobileAccountClick('account')}>Account</MenuItem>
        <MenuItem onClick={() => this.handleMobileAccountClick('bookNow')}>Book Now</MenuItem>
      </Menu>
    );
  }

  showPopover() {
    const { anchorEl, width } = this.state;
    const isNotBookingPage = this.isNotOnBookingPage();
    
    if (width <= 800) {
      return (
        <Menu
          style={{ zIndex: '999999999999' }}
          id="menu-appbar"
          getContentAnchorEl={null}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={Boolean(anchorEl)}
          onClose={() => this.setState({ anchorEl: null })}
          MenuListProps={{
            style: { backgroundColor: '#FFFFFF', boxShadow: 'none' }
          }}
        >
          <MenuItem 
            onClick={() => this.setState({ anchorEl: null })}
            style={{ 
              justifyContent: 'flex-start', 
              padding: '8px 16px',
              minHeight: '40px',
              backgroundColor: 'transparent',
              borderBottom: 'none!important',
              borderBottomColor: 'transparent',
              borderBottomStyle: 'none',
              borderBottomWidth: '0px',
              boxShadow: 'none',
            }}
            classes={{ root: 'no-border-bottom' }}
          >
            <Close style={{ fontSize: '20px', color: '#586B94' }} />
          </MenuItem>
          {width<=800 && [
            <MenuItem key="bookings" onClick={() => this.handleAccountMenuClick('bookings')}>Bookings</MenuItem>,
            <MenuItem key="inbox" onClick={() => this.handleAccountMenuClick('inbox')}>Inbox</MenuItem>,
            <MenuItem key="paymentMethods" onClick={() => this.handleAccountMenuClick('paymentMethods')}>Payment Methods</MenuItem>,
            <MenuItem key="addressBook" onClick={() => this.handleAccountMenuClick('addressBook')}>Address Book</MenuItem>,
            <MenuItem key="soothe-pass" onClick={() => this.handleAccountMenuClick('soothe-pass')}>SoothePass</MenuItem>,
            <MenuItem key="invite-friends" onClick={() => this.handleAccountMenuClick('invite-friends')}>Invite Friends</MenuItem>,
            <MenuItem key="settings" onClick={() => this.handleAccountMenuClick('settings')}>Settings</MenuItem>,
            <MenuItem key="bookNow" onClick={() => this.handleAccountMenuClick('bookNow')}>Book Now</MenuItem>,
            <MenuItem onClick={() => { window.location.href = `https://help.soothe.com/`; }}>Help</MenuItem>
          ]}
          <MenuItem onClick={this.logout}>Logout</MenuItem>
        </Menu>
      );
    }
    return (
      <Menu
        style={{ zIndex: '999999999999' }}
        id="menu-appbar"
        getContentAnchorEl={null}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={() => this.setState({ anchorEl: null })}
        MenuListProps={{
          style: { backgroundColor: '#FFFFFF', boxShadow: 'none' }
        }}
      >
        <MenuItem 
          onClick={() => this.setState({ anchorEl: null })}
          style={{ 
            justifyContent: 'flex-start', 
            padding: '8px 16px',
            minHeight: '40px',
            backgroundColor: 'transparent',
            borderBottom: 'none!important',
            borderBottomColor: 'transparent',
            borderBottomStyle: 'none',
            borderBottomWidth: '0px',
            boxShadow: 'none',
          }}
          classes={{ root: 'no-border-bottom' }}
        >
          <Close style={{ fontSize: '20px', color: '#586B94' }} />
        </MenuItem>
        {isNotBookingPage && [
          <MenuItem key="bookings" onClick={() => this.handleAccountMenuClick('bookings')}>Bookings</MenuItem>,
          <MenuItem key="inbox" onClick={() => this.handleAccountMenuClick('inbox')}>Inbox</MenuItem>,
          <MenuItem key="paymentMethods" onClick={() => this.handleAccountMenuClick('paymentMethods')}>Payment Methods</MenuItem>,
          <MenuItem key="addressBook" onClick={() => this.handleAccountMenuClick('addressBook')}>Address Book</MenuItem>,
          <MenuItem key="soothe-pass" onClick={() => this.handleAccountMenuClick('soothe-pass')}>SoothePass</MenuItem>,
          <MenuItem key="invite-friends" onClick={() => this.handleAccountMenuClick('invite-friends')}>Invite Friends</MenuItem>,
          <MenuItem key="settings" onClick={() => this.handleAccountMenuClick('settings')}>Settings</MenuItem>,
          <MenuItem key="bookNow" onClick={() => this.handleAccountMenuClick('bookNow')}>Book Now</MenuItem>,
        ]}
        <MenuItem onClick={this.logout}>Logout</MenuItem>
      </Menu>
    );
  }

  bottomNavigation() {
    const { navigationValue } = this.state;
    const loggedIn = get(this.props, 'client.loggedIn', false);
    const { hideGoBack, showMenu } = this.props;
    return (hideGoBack && !showMenu) ? <>
      <FetchClientContainer />
    </> : (
      <>
        <BottomNavigation
          showLabels
          className="mobile-toolbar br-t-opaque-2 size-12-16 contentTertiary font-weight-bold z-index-2"
          value={navigationValue}
        >
          <BottomNavigationAction
            label="Menu"
            value="booking"
            icon={<MenuBook />}
            component={Link}
            to="/booking/MENU"
            id="bookNow"
          />
          <BottomNavigationAction
            label="Bookings"
            value="appointments"
            icon={navigationValue === 'appointments' ? <EventAvailable /> : <EventAvailableOutlined />}
            component={Link}
            to="/appointments/"
            id="appointments"
          />
          <BottomNavigationAction
            label="Inbox"
            value="inbox"
            icon={(
              <Badge overlap="rectangular" color="secondary" variant="dot" invisible={!this.hasNewMessagesFlag()}>
                {navigationValue === 'inbox' ? <Message /> : <MessageOutlined />}
              </Badge>
            )}
            component={Link}
            to="/inbox/"
          />
          {hasUuid() && !loggedIn ? null : loggedIn
            ? (
              <BottomNavigationAction
                label="Logout"
                value="account"
                icon={<img className="w-h-20 br-rd-50 br-opaque" src={get(this.props, 'client.avatar_url', userAvatarPlaceholder)} alt="User avatar" />}
                component={Button}
                onClick={this.logout}
                id="avatar"
              />
            )
            : (
              <BottomNavigationAction
                label="Login"
                value="sign_on"
                icon={navigationValue === 'sign_on' ? <AccountCircle /> : <AccountCircleOutlined />}
                component={Link}
                to="/sign_on/"
              />
            )}
        </BottomNavigation>
        <FetchClientContainer />
      </>
    );
  }

  appBarHeader() {
    const { classes } = this.props;
    const { scrolledDown, accountSidebarOpen } = this.state;

    const navigationValue = accountSidebarOpen ? '' : get(split(window.location.pathname, '/', 2), '1', '');

    const { hideGoBack, showMenu } = this.props;
    const loggedIn = get(this.props, 'client.loggedIn', false);
    const isUnclosable = isUnclosableNavRoute(window.location.pathname);
    return (
      <div className={classes.root}>
        <AppBar position="fixed" elevation={scrolledDown ? 4 : 0}>
          <Toolbar className="height-80 p-16-64 align-items-center justify-content-spaced br-b-opaque">
            {!hideGoBack && !showMenu ? (
              <div className="w-33 md-ml-40">
                <a href={blankHref} onClick={this.props.relevantGoBack} className="d-flex-only align-items-center BluePrimary font-weight-bold size-18-24 deco-none">
                  <ArrowBack className="mr-12 size-18-28-imp" />
                  {' '}
                  Back
                </a>
              </div>
            ) : null}
            {hideGoBack && !showMenu ?
              <div className="w-33" />
              : null}
            {showMenu
              ? (
                <div className="w-33">
                  <Link className={`d-inline-flex BluePrimary font-weight-bold size-24-18 mr-32 deco-none ${accountSidebarOpen || isUnclosable ? 'br-b-blue-2' : ''}`} to="#"
                    onClick={(event) => {
                      if (this.state.width <= 800) {
                        // Mobile: show dropdown
                        this.setState({ mobileAccountDropdownAnchor: event.currentTarget });
                      } else {
                        // Desktop: show sidebar
                        this.handleAccountSidebarOpen();
                      }
                    }}>
                      {/* here cursor */}
                      {this.getAccountDropdownTitle()} {accountSidebarOpen ?
                        <KeyboardArrowUp className="size-18-24" />
                        : <KeyboardArrowDown className="size-18-24" />}
                  </Link>
                  {this.state.width < 800 ? null : <Link className={`BluePrimary font-weight-bold size-24-18 mr-32 deco-none ${navigationValue === 'booking' ? 'br-b-blue-2' : ''}`} to="/booking/MENU" id="bookNow">
                    {includes(window.location.pathname, '/booking/') ? "Book Now" : "Menu"}
                  </Link>}
                </div>
              ) : null}
            <div >
              <button
                type="button"
                className="btn btn-link"
                onClick={this.handleLogoClick}
                id="sootheLogo"
              >
                <img className="soothe-logo-icon height-44" src={this.state.width < 800 ? logoBlueSmall : logoBlue} alt="Soothe-small" />
              </button>
            </div>
            {hasUuid() && !loggedIn ? <div className="w-33" /> : loggedIn
              ? (
                <div className="w-33 end">
                  {this.state.width < 800 ? null : <a className="BluePrimary font-weight-bold size-24-18  mr-32 deco-none" href="https://help.soothe.com/" target="_blank" rel="noopener noreferrer">Help</a>}
                  {this.state.width > 800 ?<IconButton
                    id="avatar"
                    className="p-0-imp"
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={(event) => {
                      const { anchorEl } = this.state;
                      if (anchorEl) {
                        this.setState({ anchorEl: null });
                      } else this.setState({ anchorEl: event.currentTarget });
                    }}
                    color="inherit"
                  >
                    {get(this.props, 'client.avatar_url', null)
                      ? <img className="w-h-48 br-rd-50 sm-w-h-40" src={get(this.props, 'client.avatar_url', userAvatarPlaceholder)} alt="User avatar" />
                      : <AccountCircle className="w-h-48 sm-w-h-40" />}
              </IconButton>:<>
                    <div className="d-flex align-items-center justify-content-end">
                      <button
                        type="button"
                        className="btn btn-link p-0"
                        onClick={() => {
                          window.location.href = `${HOST_ROOT}/account/settings/`;
                        }}
                        style={{ background: 'none', border: 'none' }}
                      >
                        {get(this.props, 'client.avatar_url', null)
                          ? <img className="w-h-48 br-rd-50 sm-w-h-40" src={get(this.props, 'client.avatar_url', userAvatarPlaceholder)} alt="User avatar" />
                          : <AccountCircle className="w-h-48 sm-w-h-40" />}
                      </button>
                      <IconButton
                        id="avatar"
                        className="p-0-imp"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={(event) => {
                          const { anchorEl } = this.state;
                          if (anchorEl) {
                            this.setState({ anchorEl: null });
                          } else this.setState({ anchorEl: event.currentTarget });
                        }}
                        color="inherit"
                      >{ this.state.anchorEl ? <CollapseIcon className={classes.collapseIcon} /> : <ExpandIcon className={classes.collapseIcon} />}
                      </IconButton>
                    </div>    
              </>}
                  {this.showPopover()}
                </div>
              )
              : !this.props.goToAuthentication ? <div className="w-33 end" />
                : (
                  <div className="w-33 end">
                    <button
                      type="button"
                      className="btn small-cta-secondary mr-8"
                      onClick={() => {
                        if (this.props.goToAuthentication) {
                          this.props.goToAuthentication(true);
                        }
                      }}
                    >
                      Login
                    </button>
                    <button
                      type="button"
                      className="btn small-cta-primary"
                      onClick={() => {
                        if (this.props.goToAuthentication) {
                          this.props.goToAuthentication(false);
                        }
                      }}
                    >
                      Sign Up
                    </button>
                  </div>
                )}
          </Toolbar>
        </AppBar>
        <FetchClientContainer />
      </div>
    );
  }

  relevantHeader() {
    if (this.state.redirect) {
      return (
        <Redirect to={{
          pathname: this.state.pathname,
          state: {
            click_source: 'nav_bar',
          },
        }}
        />
      );
    }
    // if (this.state.width < 1000) {
    //   return null;
    //   // this.bottomNavigation();
    // }
    return this.appBarHeader();
  }

  render() {
    const loggedIn = get(this.props, 'client.loggedIn', false);
    const parsedParams = queryString.parse(window.location.search);
    const resetToken = get(parsedParams, 'reset_password_token', null);
    const pageIs = get(split(window.location.pathname, '/', 2), '1', '');
    return (
      <>
        {this.relevantHeader()}
        <ForcedTermsModal />
        {loggedIn || (resetToken && pageIs !== 'sign_on') ? <ResetPasswordPopups /> : null}
        {this.state.width > 800 && (
          <AccountSidebar
            open={this.state.accountSidebarOpen}
            onClose={this.handleAccountSidebarClose}
            client={this.props.client}
            loadClient={this.props.loadClient}
            width={this.state.width}
          />
        )}
        {this.state.width <= 800 && this.showMobileAccountDropdown()}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  client: state.client,
  appointment: state.appointment,
  upcomingAppointmentId: state.upcomingAppointmentId,
  chats: state.chats,
});

Navbar.propTypes = {
  client: PropTypes.object.isRequired,
};

Navbar.defaultProps = {
  bookingNav: null,
};

export default withStyles(useStyles)(
  withLocalize(connect(mapStateToProps, { loadClient, setChats })(Navbar)),
);
